import type { IgnorableFn } from '../composables/datadog'

export const SCRATCHCARD_REVEAL_ERROR_MESSAGE = 'Error revealing scratchcard'

export const DATADOG_IGNORABLE: IgnorableFn[] = [
  (_, _message, error: any) => {
    const errorPaths = ['cause.message', 'causes.stack', 'causes[0].message']

    const errorRegexes = [/AsyncData request cancelled by deduplication/i, /Fetch is aborted/i]

    return errorPaths.some((path) => {
      const property = R_prop(error, ...(R_stringToPath(path) as [string]))
      if (!property) return false
      return errorRegexes.some((regex) => regex.test(property))
    })
  },
  (_, message) => message.includes('zoid destroyed all components'),
  (_, message) => /csp_violation/i.test(message),
  (_, message) => /evaluating 'a\.L'/i.test(message),
  (_, message) => /refused to/i.test(message),
  // expected when the session expires while the player scratches -- see SF-6257
  (_, message, error) =>
    message === SCRATCHCARD_REVEAL_ERROR_MESSAGE &&
    isError(error) &&
    error.message === 'authentication.tokenexpired',
]

export const DATADOG_STATES = {
  Player: 'datadog_player',
} as const
